import { useCallback, useState } from 'react'
import { NewApiBaseUrl } from '../../consts/new-api-base-url'
import useHttpApiNew from '../../hooks/useHttpApiNew'
import { getAccessTokenFromStorage } from '../../offline/session-store'
import { getCrashCoordinates } from './crash-coordinates.util'
import { toNotificationMapCrash } from './notification-map-crash.util'
import { NOTIFICATION_CRASH_LOAD_RESULTS } from './notification-center.const'

const SINGLE_CRASH_URL = `${NewApiBaseUrl}/crash`

/**
 * Crash selected from the Notification Center and shown on the map as a preview card.
 * @param {string|null} token
 */
export function useNotificationCrash(token) {
  const { request } = useHttpApiNew()
  const [notificationCrash, setNotificationCrash] = useState(null)

  /** @returns {Promise<string>} one of NOTIFICATION_CRASH_LOAD_RESULTS */
  const showNotificationCrash = useCallback(async crashId => {
    const headers = { Authorization: `Bearer ${getAccessTokenFromStorage() || token || ''}` }
    const response = await request(`${SINGLE_CRASH_URL}/${crashId}`, 'GET', null, headers)
    if (!response || response.responseAnyError) return NOTIFICATION_CRASH_LOAD_RESULTS.ERROR
    const mapCrash = toNotificationMapCrash(response.responseData?.crashes?.[0])
    if (!mapCrash) return NOTIFICATION_CRASH_LOAD_RESULTS.NOT_FOUND
    if (!getCrashCoordinates(mapCrash)) return NOTIFICATION_CRASH_LOAD_RESULTS.NO_COORDINATES
    setNotificationCrash(mapCrash)
    return NOTIFICATION_CRASH_LOAD_RESULTS.SHOWN
  }, [request, token])

  const clearNotificationCrash = useCallback(() => setNotificationCrash(null), [])

  return { notificationCrash, showNotificationCrash, clearNotificationCrash }
}
